import { ArrowRight } from 'lucide-react';
import type { PcmpProposalStudentClass } from '../../types/pcmpProposal.types';
import { toPcmpChangeLines } from '../../utils/pcmpChangeLabels';

interface PcmpChangeListProps {
  changes: Record<string, unknown> | null;
  students: PcmpProposalStudentClass[];
}

export function PcmpChangeList({ changes, students }: PcmpChangeListProps) {
  const lines = toPcmpChangeLines(changes, { students });
  if (lines.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1 rounded-md bg-muted/50 px-3 py-2 text-xs">
      {lines.map((line) => (
        <li key={line.key} className="flex flex-wrap items-center gap-x-1.5">
          <span className="font-medium">{line.label}:</span>
          <span className="text-muted-foreground line-through">{line.from}</span>
          <ArrowRight className="size-3 shrink-0 text-muted-foreground" aria-hidden />
          <span>{line.to}</span>
        </li>
      ))}
    </ul>
  );
}
